module.exports = __webpack_public_path__ + "static/Minhazur_Rahaman_Resume-e03680c79ad8b52d9988a62afb2a90a7.pdf";